import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth-guard/auth-guard.service';
import { CallbackComponent } from './callback/pages/callback.component';

const respData = JSON.parse(window.localStorage.getItem('cepmRespData'));
let isSupplierLogin = false;
if (respData && respData?.roles && respData?.roles.length > 0) {
  if ((respData?.roles[0].value == 'scw_supplier_user')) {
    isSupplierLogin = true;
  }
}

const routes: Routes = [
  {
    path: 'callback',
    component: CallbackComponent,
  },
  {
    path: 'supplier-whitepaper',
    loadChildren: () => import(`./supplier-whitepaper/supplier-whitepaper.module`).then(
      module => module.SupplierWhitePaperModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'dashboard',
    loadChildren: () => import(`./dashboard/dashboard.module`).then(
      module => module.DashboardModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'messages',
    loadChildren: () => import(`./message/message.module`).then(
      module => module.MessageModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'contact-management',
    loadChildren: () => import(`./contact-management/contact-management.module`).then(
      module => module.ConatactManagementModule
    ),
    canActivate: [AuthGuard],
    data: { roles: ['scw_supplier_user'] },
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'audit-board',
    loadChildren: () => import(`./audit-board/audit-board.module`).then(
      module => module.AuditBoardModule
    ),
    canActivate: [AuthGuard],
    data: { roles: ['scw_admin', 'scw_supplier_user'] }
  },
  {
    path: 'tools',
    loadChildren: () => import(`./tools/tools.module`).then(
      module => module.ToolsModule
    ),
    canActivate: [AuthGuard],
    data: { roles: ['scw_supplier_user'] }

  },
  {
    path: 'documents',
    loadChildren: () => import(`./documents/documents.module`).then(
      module => module.DocumentsModule
    ),
    canActivate: [AuthGuard],
    data: { roles: ['scw_supplier_user'] },
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'lookup',
    loadChildren: () => import(`./lookup/lookup.module`).then(
      module => module.LookupModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'wizards',
    loadChildren: () => import(`./wizards/wizards.module`).then(
      module => module.WizardsModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'data-refresh',
    loadChildren: () => import(`./data-refresh/data-refresh.module`).then(
      module => module.DataRefreshModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'supplier-home',
    loadChildren: () => import(`./supplier-home/supplier-home.module`).then(
      module => module.SupplierHomeModule
    ),
    canActivate: [AuthGuard],
    data: { roles: ['scw_supplier_user'] }

  },
  {
    path: 'supplier-new-home',
    loadChildren: () => import(`./supplier-home-v2/supplier-home-v2.module`).then(
      module => module.SupplierHomeV2Module
    ),
    canActivate: [AuthGuard],
    data: { roles: ['scw_supplier_user'] },
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'questionnaire',
    loadChildren: () => import(`./questionnaire/questionnaire.module`).then(
      module => module.QuestionnairetModule
    ),
    canActivate: [AuthGuard],
    data: { roles: ['scw_supplier_user'] },

    runGuardsAndResolvers: 'always'
  },
  {
    path: 'fulfillment',
    loadChildren: () => import(`./fullfilment/fullfilment.module`).then(
      module => module.FullfilmentModule
    ),
    canActivate: [AuthGuard],
    data: { roles: ['scw_supplier_user'] }

  },
  {
    path: 'quality',
    loadChildren: () => import(`./quality/quality.module`).then(
      module => module.QualityModule
    ),
    canActivate: [AuthGuard],
    data: { roles: ['scw_supplier_user'] }

  },
  {
    path: 'baao-metrics',
    loadChildren: () => import(`./baao-metrics/baao-metrics.module`).then(
      module => module.BaaoMetricsModule
    ),
    canActivate: [AuthGuard],
    data: { roles: ['scw_supplier_user'] }

  },
  {
    path: 'events',
    loadChildren: () => import(`./events/events.module`).then(
      module => module.EventsModule
    ),
    canActivate: [AuthGuard],
    data: { roles: ['scw_supplier_user'] },
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'configuration-console',
    loadChildren: () => import(`./configuration-console/configuration-console.module`).then(
      module => module.ConfigurationConsoleModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'supplier-profile',
    loadChildren: () => import(`./supplier-profile/supplier-profile.module`).then(
      module => module.SupplierProfileModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'resiliency-score-card',
    loadChildren: () => import(`./resiliency/resiliency.module`).then(
      module => module.ResiliencyModule
    ),
    canActivate: [AuthGuard],
    data: { roles: ['scw_supplier_user'] }

  },
  {
    path: 'fhr-detailed-view',
    loadChildren: () => import(`./fhr/fhr-detailed-view.module`).then(
      module => module.FhrDetailedViewModule
    ),
    canActivate: [AuthGuard],
    data: { roles: ['scw_supplier_user'] }

  },
  {
    path: 'sbr-score-card',
    loadChildren: () => import(`./sbr/sbr.module`).then(
      module => module.SbrModule
    ),
    canActivate: [AuthGuard],
    data: { roles: ['scw_supplier_user'] }

  },
  {
    path: 'about-us',
    loadChildren: () => import(`./about-us/about-us.module`).then(
      module => module.AboutUsModule
    ),
    canActivate: [AuthGuard],
    data: { roles: ['scw_supplier_user'] }

  },
  {
    path: 'faq',
    loadChildren: () => import(`./faq/faq.module`).then(
      module => module.FaqModule
    ),
    canActivate: [AuthGuard],
    data: { roles: ['scw_supplier_user'] }

  },
  // TODO: ESG (Sustainability) route temporarily disabled
  // {
  //   path: 'supplier-sustainability-score',
  //   loadChildren: () => import(`./supplier-sustainability-score/supplier-sustainability-score.module`).then(
  //     module => module.SupplierSustainabilityScoreModule
  //   ),
  //   canActivate: [AuthGuard],
  //   data: { roles: ['scw_supplier_user'] }
  // },
  {
    path: 'supplier-summary',
    loadChildren: () => import(`./supplier-mail-summary-track/supplier-mail-summary-track.module`).then(
      module => module.SupplierMailSummaryTrackModule
    ),
    data: { roles: ['scw_supplier_user'] }
  },
  {
    path: 'logout',
    loadChildren: () => import(`./logout/logout.module`).then(
      module => module.LogoutModule
    ),
    canDeactivate: [AuthGuard]
  },
  {
    path: 'no-cepm-role',
    loadChildren: () => import(`./no-cepm-role/no-cepm-role.module`).then(
      module => module.NoCepmRoleModule
    ),
    canDeactivate: [AuthGuard]
  },
  {
    path: 'supplier-out-of-scope',
    loadChildren: () => import(`./supplier-out-of-scope/supplier-out-of-scope.module`).then(
      module => module.SupplierOutOfScopeModule
    ),
    canDeactivate: [AuthGuard]
  },
  {
    path: 'no-role-external',
    loadChildren: () => import(`./no-role-external/no-role-external.module`).then(
      module => module.NoRoleExternalModule
    ),
    canDeactivate: [AuthGuard]
  },
  {
    path: 'confirmation',
    loadChildren: () => import(`./confirmation/confirmation.module`).then(
      module => module.ConfirmationModule
    )
  },
  {
    path: 'sucm-home',
    loadChildren: () => import(`./sucm-home/sucm-home.module`).then(
      module => module.SucmHomeModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'sucm-new-home',
    loadChildren: () => import(`./sucm-home-v2/sucm-home-v2.module`).then(
      module => module.SucmHomeV2Module
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'general-user-home',
    loadChildren: () => import(`./general-user-home/general-user-home.module`).then(
      module => module.GeneralUserHomeModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'incident-management',
    loadChildren: () => import(`./incident-management/incident-management.module`).then(
      module => module.IncidentManagementModule
    ),
    canActivate: [AuthGuard],
    data: { roles: ['scw_supplier_user'] }
  },
  {
    path: 'probe',
    loadChildren: () => import(`./server-check/server-check.module`).then(
      module => module.ServerCheckModule
    ),
    canActivate: [AuthGuard],
  },
  {
    path: 'download',
    loadChildren: () => import(`./download/download.module`).then(
      module => module.DownloadModule
    ),
    canActivate: [AuthGuard],
    data: { roles: ['scw_supplier_user'] }

  },
  {
    path: 'parent-mapping',
    loadChildren: () => import(`./parent-mapping/parent-mapping-routing.module`).then(
      module => module.ParentMappingRoutingModule
    ),
    canActivate: [AuthGuard],
    data: { roles: ['admin'] }
  },
  {
    path: 'sbr-planning',
    loadChildren: () => import(`./sbr-planning-and-scorecard/sbr-planning-and-scorecard.module`).then(
      module => module.SbrPlanningAndScorecardModule
    ),
    canActivate: [AuthGuard]
  },
  {
    path: 'fhr-tracker',
    loadChildren: () => import('./fhr-tracker/fhr-tracker.module').then(m => m.FhrTrackerModule),
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: isSupplierLogin ? 'supplier-new-home' : '',
    pathMatch: 'full'
  }


];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
